import BaseCommand from "@/models/api/commands/BaseCommand";

export class ResetRelatedOrderItemCommand extends BaseCommand {
  CommandName = "ResetRelatedOrderItem";
  Command: unknown;
  constructor(sessionId: string, operationId: string, orderItemId: string, keepOrderItemFees: boolean) {
    super(sessionId, operationId);
    this.Command = { OrderItemId: orderItemId, KeepOrderItemFees: keepOrderItemFees };
  }
}
